/* eslint-disable */
import { useState, useContext, useEffect, useCallback } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../contexts";
import a11yScrollableProps from "../../../../constants/tabPanelProps/ayScrollableProps";
import ScrollTabPanel from "../../../shared/tabPanelComponent/ScrollTabPanel";

import { Box, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import EnrollmentApprovalGrid from "./enrollmentApproval/EnrollmentApprovalGrid";
import PersonalChangeRequestGrid from "./personalChangeRequest/PersonalChangeRequest";
import WaivedBenefitsGrid from "./waivedBenefitsGrid/WaivedBenefitsGrid";
import EnrollmentApproval from "./enrollmentApproval/EnrollmentApproval";
import BenefitSummary from "./benefitSummary/BenefitSummary";
import PersonalChangeRequest from "./personalChangeRequest/PersonalChangeRequest";
import VEBWaivedBenefitsGrid from "./vebWaivedBenefitsGRid/VEBWaivedBenefitsGrid";
import DependentChangeRequestGrid from "./dependentChangeRequest/DependentChangeRequestGrid";
import { useEnroller } from "../../../../hooks";
import useRouteParam from "../../../../hooks/useRouteParam";
import { GROUP_NUMBER } from "../../../../constants/groups";
import isEmployerRoute from "../../../../utils/commonFunctions/isEmployerRoute";
import { getPermissionsFromGroupOwner } from "../../../../utils/getPermissionsFromGroupOwner";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	}
}));

const EmployerDashboard = () => {
	const classes = useStyles();
	const { isEnroller, enrollerRole } = useEnroller();
	const [tabPanelValue, setTabPanelValue] = useState(0);
	const { setDashboardHeader } = useContext(UIContext);
	const { user } = useContext(AuthContext);

	const [tabsAndPanels, setTabsAndPanels] = useState([]);

	const [tabsWithPanels, setTabsWithPanels] = useState({ tabs: [], panels: [] });
	const svgHeight = 400;
	const svgWidth = 600;
	const queryGroupNumber = useRouteParam("gn");
	const handleTabLabelChange = useCallback((event, value) => {
		setTabPanelValue(value);
	}, []);

	const membersDetailsTabPermission =
		user && isEmployerRoute() && queryGroupNumber
			? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.dashboard_menu.self

			: user
				? getPermissionsFromGroupOwner(user, 0)?.dashboard_menu.self
				: null;

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.employer_dashboard);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (membersDetailsTabPermission && user) {
			const generatedTabs = [];

			// Benefit Summary
			if (membersDetailsTabPermission.benefit_summary_tab?.view) {
				generatedTabs.push({
					label: "Benefit Summary",
					component: <BenefitSummary />
				});
			}

			// Enrollment & Approval
			if (
				membersDetailsTabPermission.enrollment_and_approval_tab?.view
				//  &&
				// user.type !== "ENROLLER ADMIN" &&
				// user.type !== "AGENT"
			) {
				generatedTabs.push({
					label: "Enrollment & Approval",
					component: <EnrollmentApproval />
				});
			}

			// Personal Change Request
			if (membersDetailsTabPermission.personal_change_request_tab?.view) {
				generatedTabs.push({
					label: "Personal Change Request",
					component: <PersonalChangeRequest />
				});
			}

			// Dependent Change Request
			if (membersDetailsTabPermission.dependent_change_request_tab?.view) {
				generatedTabs.push({
					label: "Dependent Change Request",
					component: <DependentChangeRequestGrid />
				});
			}

			// Waived Benefits
			if (membersDetailsTabPermission.waived_benefits_tab?.view) {
				generatedTabs.push({
					label: "Waived Benefits",
					component: <WaivedBenefitsGrid />
				});
			}

			// VEB Waived Benefits
			if (membersDetailsTabPermission.veb_waived_benefits_tab?.view) {
				generatedTabs.push({
					label: "VEB Waived Benefits",
					component: <VEBWaivedBenefitsGrid />
				});
			}

			setTabsAndPanels(generatedTabs);
		}
	}, [membersDetailsTabPermission, user]);



	return (
		<div className="employer-dashboard-container" id="employer-dashboard-container">
			<div className="employer-dashboard-tab-panel-container" style={{ width: "auto" }}>
				<div className={classes.root + " glb-tab-panel-container"}>

					<Box sx={{ width: "100%" }}>
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs
								value={tabPanelValue}
								onChange={handleTabLabelChange}
								TabIndicatorProps={{
									style: {
										border: "none",
										backgroundColor: "#558b2f"
									}
								}}
								variant="scrollable"
								scrollButtons="auto"
								aria-label="scrollable auto tabs example"
								className="glb-tab-panel"
							>
								{tabsAndPanels.map((tab, index) => (
									<Tab
										key={index}
										label={tab.label}
										className="glb-tab-label"
										{...a11yScrollableProps(index)}
									/>
								))}
							</Tabs>

							{tabsAndPanels.map((tab, index) => (
								<ScrollTabPanel key={index} value={tabPanelValue} index={index}>
									{tab.component}
								</ScrollTabPanel>
							))}
							{/* <Tabs
								value={tabPanelValue}
								onChange={handleTabLabelChange}
								TabIndicatorProps={{
									style: {
										border: "none",
										backgroundColor: "#558b2f"
									}
								}}
								variant="scrollable"
								scrollButtons="auto"
								aria-label="scrollable auto tabs example"
								className="glb-tab-panel"
							>
								<Tab
									label={"Benefit Summary"}
									className="glb-tab-label"
									{...a11yScrollableProps(0)}
								/>
								{user && user.type !== "ENROLLER ADMIN" && user.type !== "AGENT" && (
									<Tab
										label={"Enrollment & Approval"}
										className="glb-tab-label"
										{...a11yScrollableProps(1)}
									/>
								)}

								<Tab
									label={"Personal Change Request"}
									className="glb-tab-label"
									{...a11yScrollableProps(2)}
								/>
								<Tab
									label={"Dependent Change Request"}
									className="glb-tab-label"
									{...a11yScrollableProps(3)}
								/>
								<Tab
									label={"Waived Benefits"}
									className="glb-tab-label"
									{...a11yScrollableProps(4)}
								/>
								<Tab
									label={"VEB Waived Benefits"}
									className="glb-tab-label"
									{...a11yScrollableProps(5)}
								/>
								{/* <Tab
										label={"Benefit Summary"}
										className="glb-tab-label"
										{...a11yScrollableProps(5)}
									/> */}
							{/*</Tabs>
							<ScrollTabPanel value={tabPanelValue} index={0}>
								<BenefitSummary />
							</ScrollTabPanel>
							{user && user.type !== "ENROLLER ADMIN" && user.type !== "AGENT" && (
								<ScrollTabPanel value={tabPanelValue} index={1}>
									<EnrollmentApproval />
								</ScrollTabPanel>
							)}

							<ScrollTabPanel value={tabPanelValue} index={2}>
								<PersonalChangeRequest />
							</ScrollTabPanel>
							<ScrollTabPanel value={tabPanelValue} index={3}>
								<DependentChangeRequestGrid />
							</ScrollTabPanel>
							<ScrollTabPanel value={tabPanelValue} index={4}>
								<WaivedBenefitsGrid />
							</ScrollTabPanel>
							<ScrollTabPanel value={tabPanelValue} index={5}>
								<VEBWaivedBenefitsGrid />
							</ScrollTabPanel> */}
							{/* <ScrollTabPanel value={tabPanelValue} index={5}>
									<BenefitSummary />
								</ScrollTabPanel> */}
						</Box>
					</Box>
					{/* <Box sx={{ flexGrow: 1 }} /> */}
				</div>
			</div>
		</div>
	);
};

export default EmployerDashboard;
